import { IoIosMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from 'aos';

function MobHeader() {
  const [showAboutSubmenu, setShowAboutSubmenu] = useState(false);

  const [showMenu, setShowMenu] = useState(false);


  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <div className="sticky top-0 bg-white z-20 lg:hidden">
      <div className="p-6">
        <IoIosMenu
          className="cursor-pointer text-3xl text-primary"
          onClick={() => setShowMenu(true)}
        />
      </div>

      {/* Overlay para fechar ao clicar fora */}
      {showMenu && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10"
          onClick={() => setShowMenu(false)}
        ></div>
      )}

      <div
        className={`fixed top-0 left-0 h-full w-[60%] max-w-sm bg-white shadow-md transform ${showMenu ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out z-20 p-5 font-rubik`}
      >
        {/* Ícone de fechar */}
        <IoMdClose
          className="cursor-pointer text-3xl text-primary mb-5"
          onClick={() => setShowMenu(false)}
        />

        {/* Menu */}
        <h1 className="font-roboto-slab font-bold text-[25px] mb-4">Menu</h1>
        <Link
          to="/#top"
          className="block text-lg hover:text-primary transition ease-in-out text-second font-rubik mb-3"
        >
          Home
        </Link>
        <Link
          to="/about"
          className="block text-lg hover:text-primary transition ease-in-out text-second font-rubik mb-3"
        >
          About
        </Link>
        <div className="mb-3">
          <button
            onClick={() => setShowAboutSubmenu(!showAboutSubmenu)}
            className="w-full text-left block text-lg hover:text-primary transition ease-in-out text-second font-rubik mb-2"
          >
            Voluntariado
          </button>

          {showAboutSubmenu && (
            <div className="ml-4 flex flex-col">
              <Link
                to="/volunteer/corrente-do-bem"
                className="block text-base text-second hover:text-primary transition mb-2"
              >
                Corrente do Bem
              </Link>
              <Link
                to="/volunteer/musicos"
                className="block text-base text-second hover:text-primary transition mb-2"
              >
                Músicos
              </Link>
              <Link
                to="/volunteer/palhacaria"
                className="block text-base text-second hover:text-primary transition"
              >
                Palhaçaria
              </Link>
              <Link
                to="/volunteer/criancas-atipicas"
                className="block text-base text-second hover:text-primary transition"
              >
                Crianças Atípicas
              </Link>
              <Link
                to="/volunteer/cuidados-paliativos"
                className="block text-base text-second hover:text-primary transition"
              >
                Cuidados Paliativos
              </Link>
              <Link
                to="/volunteer/casa-de-repouso"
                className="block text-base text-second hover:text-primary transition"
              >
                Casa de Repouso
              </Link>
            </div>
          )}
        </div>


        <Link
          to="/transparency"
          className="block text-lg hover:text-primary transition ease-in-out text-second font-rubik">
          Transparência
        </Link>
        <Link
          to="/abraca-keralty"
          className="block text-lg flex items-center justify-center hover:text-primary hover:bg-gray-100 p-2 mt-3 text-white bg-primary rounded transition ease-in-out text-second font-rubik">
          Abraça Keralty
        </Link>
      </div>
    </div>
  );
}

export default MobHeader;
